import Plan from "../Classes/Plan";
import {sendRedrawEvent, sendUnselectEvent} from "../Helpers/Events";

export const SHOW_PLANEDIT = 'PROJECT/SHOW_PLANE_EDIT';
export const SET_PLAN = 'PROJECT/SET_PLAN';
export const SET_MODAL = 'PROJECT/SET_MODAL';
export const ADD_PRELOADER = 'PROJECT/ADD_PRELOADER';
export const DEC_PRELOADER = 'PROJECT/DEC_PRELOADER';
export const SET_EDIT_MODE = 'PROJECT/SET_EDIT_MODE';
export const SET_SAVE_RESULT = 'PROJECT/SET_SAVE_RESULT';

const InitialState = {
    plan: new Plan(),
    planeEdit: true,
    preloaderCount:1,
    modal:'',
    editMode:false,
    saveResult:{hash:'',href:''}
};

export const actionsState = {
    showPlaneEdit:(value)=>{
        return {type:SHOW_PLANEDIT,value}
    },
    setPlan:(value)=>{
        return {type:SET_PLAN,value}
    },
    setModal:(value)=>{
        return {type:SET_MODAL,value}
    },
    decPreloader:()=>{
        return {type:DEC_PRELOADER}
    },
    addPreloader:()=>{
        return {type:ADD_PRELOADER}
    },
    setEditMode:(value)=>{
        return {type:SET_EDIT_MODE, value}
    },
    setSaveResult:(value)=>{
        return {type:SET_SAVE_RESULT, value}
    }
};

const projectReducer = (state = InitialState,action)=>{
    switch(action.type){
        case SHOW_PLANEDIT:{
            return {
                ...state,
                planeEdit: action.value
            }
        }
        case SET_PLAN:{
            return {
                ...state,
                plan: action.value
            }
        }
        case SET_MODAL:{
            return {
                ...state,
                modal:action.value
            }
        }
        case ADD_PRELOADER:{
            return {
                ...state,
                preloaderCount: state.preloaderCount+1
            }
        }
        case DEC_PRELOADER:{
            return {
                ...state,
                preloaderCount: state.preloaderCount-1
            }
        }
        case SET_EDIT_MODE:{
            return {
                ...state,
                editMode: action.value
            }
        }
        case SET_SAVE_RESULT:{
            return {
                ...state,
                saveResult: action.value
            }
        }
        default:{
            return state;
        }
    }
};

export default projectReducer;
